import { ViewModel, View } from "binder"
import { ToolTypeEditorView } from "./toolTypeEditor-view"
import { IToolType } from "../IToolType";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class ToolTypeEditorViewModel extends ViewModel implements IToolType, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
    }
    GetDefaultView(): View<ViewModel> {
        return new ToolTypeEditorView();
    }
    public getTypeId(): string {
        return "VM-D4C232B4-A04D-48A5-A3C5-E1BD22ABF5F0"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;

    closePopup(result?: any) {

    }

    async cloneTo(toolType: IToolType) {
        toolType.id = this.id;
        toolType.name = this.name;
        toolType.code = this.code;
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت نوع ابزار');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت کد ابزار تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('نوع ابزار با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت نوع ابزار', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push('نوع ابزار مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد ابزار مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(toolType: IToolType): Promise<any>;
}

export class ToolTypeInserter implements IServerUpdater {
    async execute(toolType: IToolType): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolTypeServices/CreateToolType', {
                Name: toolType.name,
                Code: toolType.code
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class ToolTypeUpdater implements IServerUpdater {
    async execute(toolType: IToolType): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolTypeServices/UpdateToolType', {
                ToolTypeId: toolType.id,
                Name: toolType.name,
                Code: toolType.code
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
